import React from 'react';

const Icon = () => (
  <g>
    <path
      d="M7 14C10.866 14 14 10.866 14 7C14 3.13401 10.866 0 7 0C3.13401 0 0 3.13401 0 7C0 10.866 3.13401 14 7 14Z"
      fill="#F0F0F0"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M1.44704 2.73826C0.897181 3.45365 0.482568 4.2782 0.24115 5.17396H3.88274L1.44704 2.73826Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M13.7589 5.17395C13.5174 4.27823 13.1028 3.45368 12.553 2.73828L10.1173 5.17395H13.7589Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M0.24115 8.82612C0.482595 9.72185 0.897209 10.5464 1.44704 11.2618L3.88265 8.82612H0.24115Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M11.2618 1.44706C10.5464 0.897201 9.72183 0.482588 8.82608 0.241142V3.8827L11.2618 1.44706Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M2.73827 12.5529C3.45366 13.1028 4.27821 13.5174 5.17394 13.7589V10.1173L2.73827 12.5529Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M5.17391 0.241142C4.27818 0.482588 3.45363 0.897201 2.73827 1.44703L5.17391 3.88267V0.241142Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M8.82611 13.7589C9.72184 13.5174 10.5464 13.1028 11.2618 12.553L8.82611 10.1173V13.7589Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M10.1173 8.82612L12.553 11.2618C13.1028 10.5464 13.5174 9.72185 13.7589 8.82612H10.1173Z"
      fill="#0052B4"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M13.9407 6.08696H7.91309H7.91306V0.0592539C7.61417 0.0203438 7.30945 0 7 0C6.6905 0 6.38583 0.0203438 6.08696 0.0592539V6.08691V6.08694H0.0592539C0.0203438 6.38583 0 6.69055 0 7C0 7.3095 0.0203438 7.61417 0.0592539 7.91303H6.08691H6.08694V13.9407C6.38583 13.9797 6.6905 14 7 14C7.30945 14 7.61417 13.9797 7.91303 13.9407V7.91309V7.91306H13.9407C13.9797 7.61417 14 7.3095 14 7C14 6.69055 13.9797 6.38583 13.9407 6.08696Z"
      fill="#D80027"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M8.8261 8.82612L11.9497 11.9498C12.0934 11.8062 12.2304 11.656 12.3612 11.5004L9.68693 8.8261H8.8261V8.82612Z"
      fill="#D80027"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M5.1739 8.82613H5.17385L2.05023 11.9497C2.19384 12.0934 2.34399 12.2304 2.49963 12.3612L5.1739 9.68688V8.82613Z"
      fill="#D80027"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M5.1739 5.17395V5.1739L2.05026 2.05023C1.9066 2.19384 1.76955 2.34399 1.63879 2.49963L4.31309 5.17393H5.1739V5.17395Z"
      fill="#D80027"
      transform="scale(1.71 1.71)"
    />
    <path
      d="M8.8261 5.17395L11.9498 2.05026C11.8062 1.90659 11.656 1.76955 11.5004 1.63882L8.8261 4.31312V5.17395Z"
      fill="#D80027"
      transform="scale(1.71 1.71)"
    />
  </g>
);

export default Icon;
